<!-- eslint-disable new-cap -->
<!-- eslint-disable camelcase -->
<!--
   V 0.2.0 - 2024-12-18
     - Took from Desktop

   V 0.1.0 - 2022-09-08

-->

<template>
  <div>
    <v-progress-linear
      v-if="isLoading"
      indeterminate
      color="blue"
    ></v-progress-linear>
    <v-row>
      <v-col>
        <div class="map_canv" :id="`map_canvas${controlId}`"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
// eslint-disable-next-line camelcase
import google_maps_trip from '@/classes/v1/GoogleMapsTrip2'

export default {
  data: function () {
    return {
      isLoading: false,
      mapCanvasId: '',
      controlId: null,
      UnitID: '',
      VehicleReg: '',
      pageMap: null
    }
  },

  /**
   *   Props
   */
  props: {
    Id: {
      type: String,
      default: 'Vue!'
    }
  }, // props

  /**
   *  V 0.1.0 - 2024-12-17
   *     - mpdiofied to use mobile api
   */
  mounted: function () {
    this.controlId = this._uid

    this.mapCanvasId = `map_canvas${this.controlId}`

    let url = `${this.$baseUrl}/api/v2/trip-plot`
    url += `/${this.Id}`

    this.UnitID = this.$route.params.UnitID
    this.VehicleReg = this.$route.params.VehicleReg

    if (this.$debug) {
      console.log(url)
    }

    // eslint-disable-next-line new-cap
    this.pageMap = new google_maps_trip(
      this.$baseUrl,
      this.$axios,
      //
      // the below: 'google' object comes form the declaration in the public
      // index.html declarations
      //
      google,
      this.$debug,
      document,
      this.mapCanvasId
    )

    this.isLoading = true

    this.$axios
      .get(url)
      .then((response) => {
        this.isLoading = false

        if (this.$debug) {
          console.log(response.data)
        }

        this.pageMap.initialiseTrips(response.data)
      })
      .catch((e) => {
        this.isLoading = false
        console.log(e)
      })
  } // mounted

} // export
</script>

<style>
.map_canv {
  position: absolute;
  left: 5px;
  width: calc(100% - 10px);
  height: calc(100% - 20px);
}
</style>
